module.exports = __webpack_public_path__ + "img/iphone-12-pro-max-frame-landscape.1cc3636.png";